<template>
  <div>
    <NavBtns></NavBtns>

    <!--廣告內頁-->
    <AdBanners ad_type="news" ref="ad_banner"></AdBanners>

    <!--最新消息-->
    <section id="newb">
      <div class="title">{{ $t('message.nav_news') }}</div>
      <div class="newsbox">
        <div class="container">
          <!--顯示模式切換-->
          <div class="btnbox row" v-if="!(is_offline || is_list_no_data)">
            <div class="col-xl-12 col-md-12">
              <div class="changebox">
                <label>
                  <div class="btn1" :class="[show_mode]">
                    <i class="fas fa-th-large"></i>
                    <input type="radio" v-model="show_mode" value="big" />
                  </div>
                </label>
                <label>
                  <div class="btn2" :class="[show_mode]">
                    <i class="fas fa-list-ul"></i>
                    <input type="radio" v-model="show_mode" value="small1" />
                  </div>
                </label>
              </div>
            </div>
          </div>
          <!--消息資料-->
          <div class="row" v-if="!(is_offline || is_list_no_data)">
            <div
              v-for="(news, news_idx) in news_list"
              class="col-xl-4 col-md-6"
              :class="[show_mode]"
              v-bind:key="news_idx"
            >
              <a @click="vOpenNewsContent(news)">
                <div class="box1">
                  <div class="orangebox"></div>
                  <div class="blackbox">
                    <div class="boxtitle">
                      {{ news['title_i18n'][$i18n.locale] }}
                    </div>
                    <img
                      class="img-fluid"
                      v-if="!news.news_img_error"
                      :src="news.news_small_img"
                      @error="vSetListImgError(news_idx)"
                    />
                    <!--圖片載入異常時顯示-->
                    <div
                      class="offlinebox"
                      :class="{ show: news.news_img_error }"
                    >
                      <div class="offallbox">
                        <div class="imgbox">
                          <img
                            class="img-fluid"
                            src="../assets/images/offline.svg"
                            alt="offline"
                          />
                        </div>
                        <div class="text">
                          {{ $t('message.pb_no_picture') }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="whitebox">
                    <div class="boxtitle">
                      {{ news['title_i18n'][$i18n.locale] }}
                    </div>
                    <div class="time">
                      {{ news.news_date }}
                      <p v-html="news['summary_i18n'][$i18n.locale]"></p>
                    </div>
                  </div>
                </div>
              </a>
            </div>
          </div>
          <!--離線提示-->
          <div class="row" v-else>
            <div
              class="offlinebox2 col-xl-12"
              :class="{ show: is_offline || is_list_no_data }"
            >
              <div class="allbox">
                <div class="imgbox">
                  <img
                    class="img-fluid"
                    src="../assets/images/offline.svg"
                    alt="offline"
                  />
                </div>
                <div class="text">
                  {{
                    is_offline
                      ? $t('message.pb_offline')
                      : $t('message.nw_list_no_data')
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="spacebox"></div>
      </div>
    </section>

    <!--明細內容視窗-->
    <section id="newc">
      <div class="newbigbox" :class="{ show: show_win }">
        <div class="blackbox" @click="vCloseNewsContent()"></div>
        <div class="allbox">
          <div class="orangebox"></div>
          <div class="blackbox">
            <div class="boxtitle">
              {{ news_content['title_i18n'][$i18n.locale] }}
            </div>
            <div class="imgbox">
              <div class="row">
                <div class="col-xl-12">
                  <img
                    class="img-fluid"
                    v-if="!news_content.news_img_error"
                    :src="news_content.news_big_img"
                    @error="vSetDetailImgError()"
                    alt="最新消息"
                  />
                  <div
                    class="offlinebox"
                    :class="{ show: news_content.news_img_error }"
                  >
                    <div class="offallbox">
                      <div class="imgbox">
                        <img
                          class="img-fluid"
                          src="../assets/images/offline.svg"
                          alt="offline"
                        />
                      </div>
                      <div class="text">{{ $t('message.pb_no_picture') }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="lineall" @click="vCloseNewsContent()">
              <div class="line1"></div>
              <div class="line2"></div>
            </div>
          </div>
          <div class="whitebox">
            <div class="time">
              {{ news_content.news_date }}
              <p v-html="news_content['news_content_i18n'][$i18n.locale]"></p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!--頁尾-->
    <GzFooter></GzFooter>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import $ from 'jquery';

// @ is an alias to /src
import NavBtns from '@/components/NavBtns.vue';
import AdBanners from '@/components/AdBanners.vue';
import GzFooter from '@/components/GzFooter.vue';
import Public from '@/scripts/public';

export default {
  name: 'News',
  components: {
    NavBtns,
    AdBanners,
    GzFooter,
  },
  data: function () {
    return {
      news_api: Public.appGetAPIURL('news_summary'),
      news_content_api: Public.appGetAPIURL('news_detail'),
      news_list: [
        // {
        // 	"news_id"		: 0,
        // 	"title_i18n"	: {
        // 		"zh-TW" : "哎呀! 最近沒有新消息。",
        // 		"en-US"	: "Oops! No news recently."
        // 	},
        // 	"news_date"		: pbGetCurrentDate("-"),
        // 	// "news_date"		: "2020-12-31",
        // 	"summary_i18n"	: {
        // 		"zh-TW" : "敬請期待。",
        // 		"en-US"	: "Stay tuned."
        // 	},
        // 	"news_small_img" : "./assets/images/news_02.jpg",
        // 	"news_img_error" : false
        // }
      ],
      news_content: {
        title_i18n: {
          'zh-TW': '哎呀! 最近沒有新消息。',
          'en-US': 'Oops! No news recently.',
        },
        news_date: Public.pbGetCurrentDate('-'),
        news_content_i18n: {
          'zh-TW': '敬請期待。',
          'en-US': 'Stay tuned.',
        },
        news_big_img: './img/default/news.jpg',
        news_img_error: false,
      },
      //顯示模式
      show_mode: 'big',
      //是否顯示彈出視窗
      show_win: false,
      //點擊的消息 id
      click_news_id: null,
    };
  },
  computed: {
    //網路連線狀態
    is_offline: function () {
      return this.net_offline && this.news_list && this.news_list.length <= 0;
      // return false
    },
    is_list_no_data: function () {
      return !this.news_list || this.news_list.length <= 0;
      // return false
    },
    ...mapState({
      net_offline: (state) => state.is_offline,
    }),
  },
  mounted: function () {
    //取得最新消息
    this.vLoadNews();
  },
  methods: {
    //網路連線狀態改變為 online 時觸發
    vNetworkOnline: function () {
      //取得最新消息
      this.vLoadNews();
      //若彈出視窗處於開啟狀態
      if (this.show_win) {
        var url = this.news_content_api + '/' + this.click_news_id;
        this.vLoadNewsContent(url);
      }
    },
    //網路連線狀態改變為 offline 時觸發
    vNetworkOffline: function () {},
    //從cache / 網路載入最新消息列表
    vLoadNews: function () {
      var ref = this;
      var url = this.news_api;
      if (!url || url <= 0) {
        return;
      }
      // 從 chaches 取得
      Public.appGetOWLockerDataFromCache(url).then((data) => {
        ref.vRenderNews(data);
      });

      // 從網路取得
      Public.appGetOWLockerDataFromNetwork(url).then((data) => {
        ref.vRenderNews(data);
      });
    },
    //依資料重新渲染畫面
    vRenderNews: function (news_data) {
      this.news_list = [];
      this.news_list = news_data;
      //為圖片設定小圖載入成功與否的註記
      if (this.news_list && this.news_list.length > 0) {
        for (var i = 0; i < this.news_list.length; i++) {
          this.news_list[i]['news_img_error'] = false;
        }
      }
    },
    //消息列表 - 小圖載入錯誤時
    vSetListImgError: function (news_idx) {
      this.news_list[news_idx]['news_img_error'] = true;
      //強制 render 畫面
      var origin_data = this.news_list[news_idx];
      this.news_list.splice(news_idx, 1, origin_data);
    },
    //開啟完整的最新消息內容
    vOpenNewsContent: function (news) {
      this.click_news_id = news.news_id;
      var url = this.news_content_api + '/' + news.news_id;
      this.vLoadNewsContent(url);
      //Gtag Event
      this.$gtag.event('詳細內容', {
        event_category: '最新消息',
        event_label: news['title_i18n']['zh-TW'],
        value: 1,
      });
    },
    //關閉完整的最新消息內容
    vCloseNewsContent: function () {
      this.show_win = false;
      this.click_news_id = null;
    },
    //從cache / 網路載入指定的最新消息內容
    vLoadNewsContent: function (url) {
      var ref = this;
      if (!url || url <= 0) {
        return;
      }
      // 從 chaches 取得
      Public.appGetOWLockerDataFromCache(url).then((data) => {
        ref.vRenderNewsContent(data);
      });

      // 從網路取得
      Public.appGetOWLockerDataFromNetwork(url).then((data) => {
        ref.vRenderNewsContent(data);
      });
    },
    //依資料渲染彈出視窗
    vRenderNewsContent: function (news_data) {
      if (news_data && !Public.pbIsEmptyObject(news_data)) {
        this.news_content = news_data;

        //預設最新消息內容
      } else {
        for (var i = 0; i < this.news_list.length; i++) {
          if (this.news_list[i]['news_id'] == this.click_news_id) {
            this.news_content = {
              title_i18n: this.news_list[i]['title_i18n'],
              news_date: this.news_list[i]['news_date'],
              news_content_i18n: this.news_list[i]['summary_i18n'],
              news_big_img: this.news_list[i]['news_small_img'],
              news_img_error: false,
            };
            break;
          }
        }
      }
      this.show_win = true;
      //視窗開啟時自動滑到最上面
      $('html , body').animate({ scrollTop: 0 }, 500);
    },
    //消息內容 - 大圖載入錯誤時
    vSetDetailImgError: function () {
      this.news_content['news_img_error'] = true;
      //強制 render 畫面
      var origin_data = this.news_content;
      this.news_content = null;
      this.news_content = origin_data;
    },
  },
  watch: {
    net_offline: function (new_val) {
      if (new_val) {
        this.vNetworkOffline();
      } else {
        this.vNetworkOnline();
      }
    },
  },
};
</script>
